import React from 'react';
import Container from '../common/Container';

const Testimonial = () => {
  return <Container></Container>;
};

export default Testimonial;
